/* eslint-disable complexity */
import { type EChartsExtensionInstallRegisters } from 'echarts';
import type ExtensionAPI from 'echarts/types/src/core/ExtensionAPI';

// 目前仅适用单个grid的情况，即单X轴，单Y轴
function dvLocationHandle(chart: ExtensionAPI) {
  const option = chart.getOption();
  const xAxisOption = option.xAxis;
  const yAxisOption = option.yAxis;
  if (!xAxisOption || xAxisOption.length !== 1 || !yAxisOption || yAxisOption.length !== 1) {
    return;
  }
  const xAxisOptionTarget = xAxisOption[0];
  //   const yAxisOptionTarget = yAxisOption[0];

  if (!xAxisOptionTarget.dvNameLocation) {
    return;
  }

  const gridRect = chart.getModel().getComponent('grid').coordinateSystem.getRect();

  const xAxisModel = chart.getModel().getComponent('xAxis', 0);
  const xAxisView = chart.getViewOfComponentModel(xAxisModel);

  const xAxisZr = xAxisView.group.childAt(0);
  const textZr = xAxisZr.childAt(0);
  const labelsZr = textZr._children.filter(d => d.anid.includes('label'));
  const firstLabel = labelsZr[0];
  const nameZr = textZr._children.find(d => d.anid === 'name');
  if (!nameZr) {
    return;
  }
  const xNameLocation = { x: 0, y: 0 };
  let alignStyle = '';

  if (xAxisOptionTarget.dvNameLocation === 'left') {
    xNameLocation.x = gridRect.x;
    xNameLocation.y = gridRect.y + gridRect.height + xAxisOptionTarget.nameGap;
    alignStyle = 'left';
  } else if (xAxisOptionTarget.dvNameLocation === 'center') {
    xNameLocation.x = gridRect.x + gridRect.width / 2;
    xNameLocation.y = gridRect.y + gridRect.height + xAxisOptionTarget.nameGap;
    alignStyle = 'center';
  } else {
    xNameLocation.x = gridRect.x + gridRect.width;
    xNameLocation.y = gridRect.y + gridRect.height + xAxisOptionTarget.nameGap;
    alignStyle = 'right';
  }
  const ECHARTS_DEFAULT_AXIS_LABEL_MARGIN = 8;
  const labelMargin = xAxisOptionTarget?.axisLabel?.margin || ECHARTS_DEFAULT_AXIS_LABEL_MARGIN;
  const offset = firstLabel?.style?.fontSize || 0;

  nameZr.stopAnimation();
  nameZr.attr({
    x: xNameLocation.x,
    y: xNameLocation.y + offset + labelMargin,
    style: {
      align: alignStyle,
      verticalAlign: 'top'
    }
  });
}

/**
 *
 * @param registers
 */
export function xAxisExtensionInstall(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('afterupdate', (_, chart) => {
    // dvLocationHandle(chart);
  });
}
